<template>
  <tr>
  	<td>
      <router-link :to="`/proforma-invoice/${item.code}/view`" :key="item.code" title="View Order">
        {{ item.code }}
      </router-link>
    </td>
    <td>{{ formatMysqlDate(item.added_time, 'Do MMM, YYYY') }}</td>
    <td>{{ item.type == config.invoiceTypes.customer ? 'Customer' : 'Franchisee' }}</td>
    <td>{{ item.type == config.invoiceTypes.customer ? item.customer_name : item.franchisee_name }}</td>
    <td>{{ item.retailer_name }}</td>
    <!-- <td class="text-xs-right">{{ item.total | roundValue }}</td> -->
    <!-- <td class="text-xs-right">{{ item.discount }}</td> -->
    <!-- <td class="text-xs-right">{{ item.tax | roundValue }}</td> -->
    <td class="text-xs-right">{{ item.grandtotal | roundValue }}</td>
    <td class="text-xs-center">{{ status }}</td>
    <td class="align-center justify-center layout px-0" v-if="!viewMode">
      <router-link :to="`/proforma-invoice/${item.code}/approve`" title="Approve" v-if="isConfirmed && hasApproveAccess">
        <v-icon small color="green" class="mr-1">done</v-icon>
      </router-link>
      <v-icon small class="mr-1" color="red" v-if="isConfirmed && hasApproveAccess" @click="$emit('confirmCancel', item)">clear</v-icon>
      <v-icon small class="mr-1" v-if="isApproved && hasShipAccess" @click="$emit('confirmShip', item)" title="Ship Order">near_me</v-icon>
      <v-icon small class="mr-1" color="green" v-if="isShipped && hasDeliveryAccess" @click="$emit('confirmDelivery', item)" title="Deliver Order">done_all</v-icon>
      <a :href="`#/proforma-invoice/${item.code}/print`" v-if="!isCancelled" target="_new" title="Print Order" class="hidden-sm-and-down">
        <v-icon small class="mr-1">print</v-icon>
      </a>
      <a :href="`#/proforma-invoice/${item.code}/w-print`" v-if="isApproved" target="_new" title="Warehouse Print" class="hidden-sm-and-down">
        <v-icon small class="mr-1">description</v-icon>
      </a>
    </td>
  </tr>
</template>
<script>
export default {
  name: 'SalesListItem' ,
  props: {
    item: {
      required: true
    },
    viewMode: false
  },
  data () {
    return {
      
    }
  },
  
  methods: {

  },

  mounted () {
  	
  },

  computed: {
    
    isPending () {
      return this.item.status == this.config.invoiceStatus.pending
    },

    isConfirmed () {
      return this.item.status == this.config.invoiceStatus.confirmed
    },

    isApproved () {
      return this.item.status == this.config.invoiceStatus.approved
    },

    isCancelled () {
      return this.item.status == this.config.invoiceStatus.cancelled
    },

    isShipped () {
      return this.item.status == this.config.invoiceStatus.shipped
    },

    isDelivered () {
      return this.item.status == this.config.invoiceStatus.delivered
    },

    status () {
      let status = ""
      switch(this.item.status) {
        case this.config.invoiceStatus.pending:
          status = "Pending"
        break
        case this.config.invoiceStatus.confirmed:
          status = "Confirmed"
        break
        case this.config.invoiceStatus.approved:
          status = "Approved"
        break
        case this.config.invoiceStatus.cancelled:
          status = "Cancelled"
        break
        case this.config.invoiceStatus.shipped:
          status = "Shipped"
        break
        case this.config.invoiceStatus.delivered:
          status = "Delivered"
        break
      }
      return status
    },

    hasApproveAccess () {
      return this.hasAdminPrivilage || this.isSalesManager
    },

    hasShipAccess () {
      return this.hasAdminPrivilage || this.isShippingManager
    },

    hasDeliveryAccess () {
      return this.hasAdminPrivilage || this.isShippingStaff
    },

  },

  watch: {
    
  }
}
</script>